export default __webpack_public_path__ + "media/salad_banner_mobile_en.14306672.png";